import ManualHome from '../views/OperationsManual/ManualHome.vue';
import ManualChapter from '../views/OperationsManual/ManualChapter.vue';
import ManualVersionHistory from '../views/OperationsManual/ManualVersionHistory.vue';
import { MANUAL_ROUTES } from '../components/OperationsManual/manualCopy';

const BASE_PATH = 'manual-operaciones';

export default [
  {
    path: `${BASE_PATH}/:manualKey/capitulos/:chapterSlug`,
    name: MANUAL_ROUTES.chapter,
    meta: { auth: true },
    components: { default: ManualChapter },
  },
  {
    path: `${BASE_PATH}/:manualKey/versiones`,
    name: MANUAL_ROUTES.history,
    meta: { auth: true },
    components: { default: ManualVersionHistory },
  },
  {
    path: `${BASE_PATH}/:manualKey?`,
    name: MANUAL_ROUTES.home,
    meta: { auth: true },
    components: { default: ManualHome },
  },
];
